import { getMenuId, setMenuId } from '@/utils/auth'
const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    isKeep:true,
  },
  mutations: {
    ADD_VISITED_VIEWS: (state, view) => {
      for (const temp in state.visitedViews) {
        if (state.visitedViews[temp].path === view.path) {
          setMenuId(state.visitedViews[temp].menuId)
          state.visitedViews[temp].oldQuery = state.visitedViews[temp].query;
          state.visitedViews[temp].query = view.query;
          return
        }
      }
      state.visitedViews.push({
        menuId: getMenuId(),
        name: view.name,
        path: view.path,
        query: view.query,
        oldQuery:view.oldQuery,
        title: view.meta.title || 'no-name'
      })
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, i + 1)
          break
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews = []
      state.cachedViews = []
    },
    RE_FRESH_VIEWS:(state,view) =>{
      state.isKeep = view;
    }
  },
  actions: {
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    reFreshViews({ commit, state },view) {
        commit('RE_FRESH_VIEWS',view)
    }
  }
}

export default tagsView
